module.exports = "../fonts/HelveticaNeueLTW01-45Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-45Light.eot
// module id = UUnl
// module chunks = 1